export default class BackofficeOperationDataTable {
  constructor(tableId) {
    this.tableId = tableId;
    this.initDataTable();
    this.bindEvents();
  }

  initDataTable() {
    const self = this;
  
    const $table = $(this.tableId);
    const data_order = $table.data('order-by');
    const exportFilename = $table.data('export-filename') || 'nexloop_export';
    const ajaxUrl = $table.data('ajax-url');
    
    // Use data attribute for hidden columns if available, otherwise fall back to finding d-none columns
    let hiddenColumnIndexes = [];
    if ($table.data('hidden-columns')) {
      hiddenColumnIndexes = $table.data('hidden-columns').split(',').map(Number);
    } else {
      $(this.tableId + ' thead th.d-none').each(function() {
        hiddenColumnIndexes.push($(this).index());
      });
    }
  
    const dataTableOptions = {
      "dom": '<"datatable-controls d-flex justify-content-between"Blf>rtip',
      "responsive": true,
      "searching": true,
      "columnDefs": [
        {
          "targets": -1,
          "orderable": false
        },
        {
          "targets": hiddenColumnIndexes,
          "visible": false,
          "searchable": false
        }
      ],
      "language": {
        url: '/assets/data-tables/locales/' + I18n.locale + '.json',
        previous: "<i class='mdi mdi-chevron-left'>",
        next: "<i class='mdi mdi-chevron-right>",
      },
      "buttons": [
        {
          extend: 'csvHtml5',
          text: 'Export CSV',
          className: 'd-none',
          filename: exportFilename,
          exportOptions: {
            columns: ':not(:last-child)' // This will include all columns except the last one (action column)
          }
        },
        {
          extend: 'excelHtml5',
          text: 'Export Excel',
          className: 'd-none',
          filename: exportFilename,
          exportOptions: {
            columns: ':not(:last-child)' // This will include all columns except the last one (action column)
          }
        }
      ],
      initComplete: function() {
        $(self.tableId + "_filter").addClass('d-none');
        
        $(self.tableId + '_length').appendTo('.datatable-controls');
        $("#datatable-controls").appendTo('.datatable-controls');
  
        $(".dt-buttons").addClass("d-none");
      }
    };

    // Determine loader selector based on table ID
    this.loaderSelector = this.getLoaderSelector();

    // Add AJAX configuration if URL is provided
    if (ajaxUrl) {
      dataTableOptions.processing = false; // Disable default processing indicator
      dataTableOptions.serverSide = true;
      dataTableOptions.ajax = {
        url: ajaxUrl,
        type: 'GET',
        data: function(d) {
          // Add current page filters from URL parameters
          const urlParams = new URLSearchParams(globalThis.location.search);
          
          // Add filter parameters from URL
          for (const [key, value] of urlParams.entries()) {
            if (key !== 'draw' && key !== 'start' && key !== 'length') {
              d[key] = value;
            }
          }

          // Add table-specific data attributes
          const orderStep = $table.data('order-step');
          const studyRequestStep = $table.data('study-request-step');
          const workflowName = $table.data('workflow-name');
          const studyRequestId = $table.data('study-request-id');
          
          if (orderStep) d.order_step = orderStep;
          if (studyRequestStep) d.study_request_step = studyRequestStep;
          if (workflowName) d.workflow_name = workflowName;
          if (studyRequestId) d.study_request_id = studyRequestId;

          // Add filter form data if available
          const filterForm = $('#filter-form');
          if (filterForm.length) {
            const formData = new FormData(filterForm[0]);
            for (const [key, value] of formData.entries()) {
              if (value && value.trim() !== '') {
                if (d[key]) {
                  // If the key already exists, convert to array or append to array
                  if (Array.isArray(d[key])) {
                    d[key].push(value);
                  } else {
                    d[key] = [d[key], value];
                  }
                } else {
                  d[key] = value;
                }
              }
            }
          }

          return d;
        },
        beforeSend: () => {
          // Show custom loader
          $(self.loaderSelector).show();
        },
        complete: () => {
          // Hide custom loader
          $(self.loaderSelector).hide();
        },
        error: (xhr, error, thrown) => {
          // Hide custom loader on error
          $(self.loaderSelector).hide();
          console.error('DataTables AJAX error:', error, thrown);
          application.errorNotification('Erreur lors du chargement des données');
        }
      };
    }
  
    if (data_order !== null && data_order !== "") {
      dataTableOptions.order = [[data_order, "desc"]];
    } else {
      dataTableOptions.order = [];
    }
  
    this.table = $(this.tableId).DataTable(dataTableOptions);
  }

  bindEvents() {
    const self = this;

    $(".select-multiple").select2({
      multiple: true,
      closeOnSelect: false,
      width: '100%'
    });

    $("#filter-form-submit").on('click', function() {
      $("#filter-form").trigger('submit');
      $(".spinner-border").removeClass('d-none');
      $(this).prop('disabled', true);
    });

    $("#customSearch").on('keyup', function() {
      self.table.search($(this).val()).draw();
    });

    // Export buttons
    $("#export-csv").on('click', function() {
      self.table.button('.buttons-csv').trigger();
    });

    $("#export-excel").on('click', function() {
      self.table.button('.buttons-excel').trigger();
    });
  }

  getLoaderSelector() {
    // Determine loader selector based on table ID
    if (this.tableId === '#orders-datatable') {
      return '#orders-loader';
    }

    if (this.tableId === '#sr-datatable') {
      return '#sr-loader';
    }

    if (this.tableId === '#moe-orders-datatable') {
      return '#moe-orders-loader';
    }

    // Default fallback
    return '#orders-loader';
  }

  reloadTable() {
    if (this.table && this.table.ajax) {
      $(this.loaderSelector).show();
      this.table.ajax.reload(() => {
        $(this.loaderSelector).hide();
      });
    }
  }

  updateFilters(newFilters) {
    const $table = $(this.tableId);
    
    // Update data attributes
    Object.keys(newFilters).forEach(key => {
      $table.data(key, newFilters[key]);
    });
    
    // Reload the table
    this.reloadTable();
  }

  onDestroy() {
    this.table.destroy();
  }
}